type CountryConfig = {
  label: string;
  phonePrefix: string;
};

const Countries: Record<string, CountryConfig> = {
  fr: {
    label: "france",
    phonePrefix: "+33",
  },
  be: {
    label: "belgium",
    phonePrefix: "+32",
  },
};

export default Countries;
